import locale from "localization";
import Validation from "utils/validation.utils";

const initialState = (isExpired) => {
  if (isExpired && isExpired === "false") {
    return {
      password: {
        name: "password",
        placeholder: "",
        value: "",
        maxLength: 75,
        label: locale.pleaseEnterANewPassword,
        validations: [
          Validation.required(),
          Validation.minlength(8, locale.use8CharWithMix),
          Validation.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).+$/, {
            customMessage: locale.use8CharWithMix,
          }),
        ],
      },
      confirmPassword: {
        name: "confirmPassword",
        placeholder: "",
        value: "",
        maxLength: 75,
        validations: [
          Validation.required(),
          Validation.custom(
            (field, fields) => fields?.password?.value && fields?.password?.value === field.value,
            {
              customMessage: locale.doesntMatch,
            }
          ),
        ],
      },
    };
  }

  return {
    email: {
      name: "email",
      label: locale.pleaseEnterYourEmailAddress,
      required: true,
      maxLength: 75,
      validations: [Validation.required(), Validation.emailAddress()],
    },
  };
};

export default initialState;
